import React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { viewSaleBill } from '../../../redux/actions/Billing.action';
import { getAbout } from '../../../redux/actions/Master.action';
import { toWords } from 'number-to-words';

const SalesPrint = ({ billRef, selectedId }) => {
  const dispatch = useDispatch();
  const printData = useSelector((state) => state.bills);
  const aboutData = useSelector((state) => state.master);

  const userData = printData?.viewSaleBill?.data?.data;
  console.log('userData', userData);

  useEffect(() => {
    dispatch(viewSaleBill(selectedId));
    dispatch(getAbout());
  }, [selectedId, dispatch]);

  const aboutInfo = aboutData?.getAbout?.data?.data?.map((res) => {
    return res;
  });
  console.log('aboutInfo', aboutInfo);

  const totalQty = userData?.productList?.reduce(
    (sum, res) => sum + Number(res.qty),
    0,
  );
  const totalDis = userData?.productList?.reduce(
    (sum, res) => sum + Number(res.discount),
    0,
  );
  // const totalAmount = userData?.productList?.reduce((sum, res) => sum + Number(res.amount || 0), 0) || 0;
  const totalAmount = parseFloat(userData?.billAmount) || 0;
  console.log('totalAmount', totalAmount);

  const totalAmountInWords = toWords(totalAmount);

  return (
    <div className="d-none" style={{ fontSize: '9px' }}>
      <div
        ref={billRef}
        style={{
          fontFamily: 'Arial, sans-serif',
          backgroundColor: '#fff',
          width: '100%',
          maxWidth: '595pt',
          minHeight: '842pt',
          overflow: 'hidden',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          margin: 'auto',
        }}
      >
        <div
          style={{
            width: '100%',
            borderBottom: '1px solid #A0AEC0',
            paddingBottom: '5px',
            padding: '10mm',
            height: '70px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ marginBottom: '10px' }}>
            <img src={aboutInfo?.[0]?.logo} alt="" style={{ height: '70px' }} />
          </div>
          <div style={{ fontSize: '15px', color: 'black', width: '300px' }}>
            {aboutInfo?.[0]?.address}{' '}
            <div style={{ marginTop: '5px' }}>
              <span style={{ fontWeight: 'bold' }}>Phone No:</span>{' '}
              {aboutInfo?.[0]?.mobileNumber}
            </div>
          </div>
        </div>

        <div
          style={{
            flex: '1',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              width: '100%',
              paddingLeft: '10px',
              fontSize: '11px',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <p>
                  <strong>Patient Name : </strong> {userData?.patientName}
                </p>
                <p>
                  <strong>Invoice Number : </strong> {userData?.invoiceNo}
                </p>
              </div>
              <div>
                <p>
                  <strong>Dr. Name : </strong> DR. Kinjal Pathak
                </p>
                <p>
                  <strong>Bill Date : </strong>
                  {new Date(userData?.invoiceDate).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })}
                </p>
              </div>
              <div>
                <p>
                  <strong>City : </strong> {userData?.city}
                </p>
              </div>
            </div>
            <hr style={{ color: '#d68000', fontWeight: 'bold' }} />
            <div
              style={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <table
                style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  marginTop: '10px',
                  textAlign: 'center',
                  flex: '1',
                  overflow: 'auto',
                }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        wordWrap: 'break-word',
                      }}
                    >
                      SR.
                    </th>
                    <th
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        wordWrap: 'break-word',
                      }}
                    >
                      Company
                    </th>
                    <th
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        wordWrap: 'break-word',
                      }}
                    >
                      Description
                    </th>
                    <th
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        wordWrap: 'break-word',
                      }}
                    >
                      Pack
                    </th>
                    <th
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        wordWrap: 'break-word',
                      }}
                    >
                      HSN
                    </th>
                    <th
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        wordWrap: 'break-word',
                      }}
                    >
                      Exp. Date
                    </th>
                    <th
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        wordWrap: 'break-word',
                      }}
                    >
                      Batch No.
                    </th>
                    <th
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        wordWrap: 'break-word',
                      }}
                    >
                      Qty
                    </th>
                    <th
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        wordWrap: 'break-word',
                      }}
                    >
                      MRP
                    </th>
                    {/* <th style={{ border: '1px solid gray', padding: '8px' }}>Rate</th> */}
                    <th style={{ border: '1px solid gray', padding: '8px' }}>
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {userData?.productList?.length > 0 ? (
                    userData?.productList?.map((res, index) => {
                      return (
                        <tr valign="top" key={index}>
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                              textTransform: 'uppercase',
                            }}
                          >
                            etdicare
                          </td>
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                              textTransform: 'uppercase',
                            }}
                          >
                            {res.productName}
                          </td>
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                              textTransform: 'uppercase',
                            }}
                          >
                            {res.pack}
                          </td>
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                            }}
                          >
                            {res.hsnCode}
                          </td>
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                            }}
                          >
                            {new Date(res?.expDate).toLocaleDateString(
                              'en-GB',
                              { month: '2-digit', year: 'numeric' },
                            )}
                          </td>
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                              textTransform: 'uppercase',
                            }}
                          >
                            {res.batchNo}
                          </td>
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                            }}
                          >
                            {res.qty}
                          </td>
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                            }}
                          >
                            {res.mrp}
                          </td>
                          {/* <td style={{ border: '1px solid gray', padding: '8px' }}>{res.rate}</td> */}
                          <td
                            style={{
                              border: '1px solid gray',
                              padding: '8px',
                              fontSize: '12px',
                            }}
                          >
                            {res.amount}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={11} align="center">
                        No any data
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        textAlign: 'left',
                        textTransform: 'capitalize',
                      }}
                    >
                      Rs: {totalAmountInWords}
                    </td>
                    <td style={{ border: '1px solid gray', padding: '8px' }}>
                      {totalQty}
                    </td>
                    <td
                      style={{ border: '1px solid gray', padding: '8px' }}
                    ></td>
                    <td style={{ border: '1px solid gray', padding: '8px' }}>
                      {userData?.grossAmount}
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={5}
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        textAlign: 'left',
                      }}
                    >
                      <p>
                        <strong>D.L. No. : </strong> GJ-SUR-2
                      </p>
                      <p>
                        <strong>GSTN : </strong> {aboutInfo?.[0]?.gstIn},
                        Registered
                      </p>
                      <p>
                        <strong>PAN : </strong> {aboutInfo?.[0]?.panNo}
                      </p>
                      <p></p>
                    </td>
                    <td
                      valign="top"
                      colSpan={3}
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        textAlign: 'right',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          height: '100px',
                        }}
                      >
                        <p style={{ margin: '0px' }}>
                          <strong>For, ARK CHEMIST</strong>
                        </p>
                        <p style={{ margin: '0px', marginTop: 'auto' }}>
                          <img
                            src={aboutInfo?.[0]?.signature}
                            alt=""
                            style={{ height: '70px' }}
                          ></img>
                          <strong style={{ display: 'block' }}>
                            Authorised Signatory
                          </strong>
                        </p>
                      </div>
                    </td>
                    <td
                      valign="top"
                      style={{ border: '1px solid gray', padding: '8px' }}
                    >
                      <p>
                        <strong>Gross</strong>
                      </p>
                      {totalDis > 0 && (
                        <p>
                          <strong>Discount</strong>
                        </p>
                      )}
                      <p>
                        <strong>SGST</strong>
                      </p>
                      <p>
                        <strong>CGST</strong>
                      </p>
                      <p>
                        <strong>Discount</strong>
                      </p>
                    </td>
                    <td
                      valign="top"
                      style={{ border: '1px solid gray', padding: '8px' }}
                    >
                      <p>
                        <strong>{userData?.grossAmount}</strong>
                      </p>
                      {totalDis > 0 && (
                        <p>
                          <strong>{totalDis} %</strong>
                        </p>
                      )}
                      <p>
                        <strong>{userData?.sgst}</strong>
                      </p>
                      <p>
                        <strong>{userData?.cgst}</strong>
                      </p>
                      <p>
                        <strong>
                          {userData?.discountAmount &&
                          parseFloat(userData?.discountAmount) > 0
                            ? userData?.discountAmount
                            : userData?.cDiscount &&
                                parseFloat(userData?.cDiscount) > 0
                              ? (parseFloat(userData?.billAmount) *
                                  parseFloat(userData?.cDiscount)) /
                                100
                              : 0}
                        </strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td
                      colSpan={5}
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        textAlign: 'left',
                      }}
                    >
                      {/* <p style={{ margin: '0px' }}>Consult Doctor Before Use of Medicine</p>
                                            <p style={{ margin: '0px' }}>Subject to PALANPUR Jurisdiction only.</p> */}
                      <b>Payment Type:</b> {userData?.paymentType}
                    </td>
                    <td
                      valign="top"
                      colSpan={3}
                      style={{
                        border: '1px solid gray',
                        padding: '8px',
                        textAlign: 'left',
                      }}
                    >
                      <p>
                        <strong>Message: </strong>
                      </p>
                    </td>
                    <td
                      valign="top"
                      style={{ border: '1px solid gray', padding: '8px' }}
                    >
                      <p>
                        <strong>Grand Total</strong>
                      </p>
                    </td>
                    <td
                      valign="top"
                      style={{ border: '1px solid gray', padding: '8px' }}
                    >
                      <p>
                        <strong>{userData?.billAmount}</strong>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* <div
                    style={{
                        position: 'fixed',
                        bottom: '0',
                        width: "100%",
                        borderTop: "5px solid #f2c07b",
                        paddingLeft: "15px",
                        paddingRight: '15px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingBottom: "10px",
                        boxSizing: 'border-box',
                    }}
                >
                    <div style={{ marginTop: '10px' }}>
                        <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>Sculpt Skin Care</span>
                        <p style={{ fontSize: '16px', color: 'black', width: "300px" }}>
                            503, Swastik House, Kargil Chowk, Nr. Shardayatan School, Piplod, Surat, Gujarat 395007
                        </p>
                    </div>
                    <div style={{ marginTop: '15px', display: "grid" }}>
                        <p style={{ fontSize: "16px", color: "black", display: "flex", gap: '5px', marginBottom: "0px" }}>
                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>CALL: </span> +91 75750 96668
                        </p>
                        <p style={{ fontSize: "16px", color: "black", display: "flex", gap: '5px', marginBottom: "20px" }}>
                            <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#f0cf9b' }}>WEBSITE: </span> sculptskincare.in
                        </p>
                    </div>
                </div> */}
      </div>
    </div>
  );
};

export default SalesPrint;
